import type { ClientCostCategory } from "@repo/shared/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { del, get, patch, post } from "@/lib/api/_client";

const KEY = ["clientCostCategories"] as const;
const BASE = "/internal/client-cost-categories";

export function useClientCostCategories() {
  const { data, error, isLoading } = useQuery({
    queryKey: KEY,
    queryFn: () => get<ClientCostCategory[]>(BASE),
  });
  return { clientCostCategories: data ?? [], error, isLoading };
}

export function useCreateClientCostCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => post(BASE, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateClientCostCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Record<string, unknown> }) =>
      patch(`${BASE}/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteClientCostCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => del(`${BASE}/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useToggleClientCostCategoryActive() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => post(`${BASE}/${id}/toggle-active`, {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
